import { alertError } from "@cems-eco/core/src/utils/widget";
import iremoteBloc from "../../services/bloc";
import { ElLoading } from "element-plus";
import { Vue } from "vue-class-component";
import guard from "@/guard";
import moment from "moment";
import $ from "jquery";

export abstract class IRemotePage extends Vue {
  iremoteBloc = iremoteBloc;
  options = {};
  headers: any = {
    responseType: "json",
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  adv: any = {
    stack_id: null,
    start_read_date_time: null,
    end_read_date_time: null,
    start_date_time: null,
    end_date_time: null,
  };
  dt: any;

  async mounted() {
    const loader = ElLoading.service({ lock: true });
    this.updateHeaders();
    await this.builDataTable();
    console.log(this.options)
    loader.close();
  }

  updateHeaders() {}

  async builDataTable() {
    const url = this.iremoteBloc.getIRemoteUrl();
    this.options = {
      mobileView: {
        header: {
          title: function (data: any) {
            return data.stack_id;
          },
        },
      },
      serverSide: true,
      ajax: {
        url: url,
        method: "GET",
        dataType: "json",
        dataFilter: (data) => {
          const parsedData = JSON.parse(data);
          return JSON.stringify(parsedData.data);
        },
        error: function (xhr, error, code) {
          if (xhr.status == 401) {
            alertError("Your session is expired, please re-login");
            return guard.logout();
          }

          console.log(xhr, error, code);
          alertError(code);
        },
        headers: this.headers,
      },
      columns: [
        { data: "stack_id", mobileView: false },
        { data: "read_date_time", mobileView: true },
        { data: "date_time", mobileView: true },
        { data: "log_message", mobileView: true },
      ],
    };
  }

  searching() {
    this.adv.start_read_date_time = this.adv.start_read_date_time
      ? moment(this.adv.start_read_date_time).format("yyyy-MM-DD")
      : null;
    this.adv.end_read_date_time = this.adv.end_read_date_time
      ? moment(this.adv.end_read_date_time).format("yyyy-MM-DD")
      : null;
    this.adv.start_date_time = this.adv.start_date_time
      ? moment(this.adv.start_date_time).format("yyyy-MM-DD")
      : null;
    this.adv.end_date_time = this.adv.end_date_time
      ? moment(this.adv.end_date_time).format("yyyy-MM-DD")
      : null;

    const params: any = {
      scope: "search",
      scopeSearch: {
        stack_id: this.adv.stack_id,
      },
    };

    if (this.adv.start_read_date_time && this.adv.end_read_date_time) {
      params.scopeSearch.read_date = `${this.adv.start_read_date_time} 00:00:00,${this.adv.end_read_date_time} 23:59:59`;
    }

    if (this.adv.start_date_time && this.adv.end_date_time) {
      params.scopeSearch.log_date = `${this.adv.start_date_time} 00:00:00,${this.adv.end_date_time} 23:59:59`;
    }
    const searchUrl = this.iremoteBloc.getIRemoteUrl(params);
    this.dt = $(".iremote-table").DataTable();
    this.dt.ajax.url(searchUrl);
    this.dt.ajax.reload();
  }

  reset() {
    const tableUrl = this.iremoteBloc.getIRemoteUrl();
    this.dt = $(".iremote-table").DataTable();
    this.dt.ajax.url(tableUrl);
    this.dt.ajax.reload();
  }
}
